(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3805],{

/***/ 79313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ is_prop_valid_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);


/***/ }),

/***/ 38845:
/***/ (function(module) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),

/***/ 98066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseDelay = __webpack_require__(38845),
    baseRest = __webpack_require__(5976),
    toNumber = __webpack_require__(14841);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),

/***/ 97174:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply",
      function () {
        return __webpack_require__(11922);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3789);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14257);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4612);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51419);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18029);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_startCase__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);
/* harmony import */ var components_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11665);
/* harmony import */ var constants_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88501);









var FormItem = function(props) {
    var name = props.name, label = props.label, _type = props.type, type = _type === void 0 ? "text" : _type, placeholder = props.placeholder, _isRequired = props.isRequired, isRequired = _isRequired === void 0 ? true : _isRequired, children = props.children, helperText = props.helperText, readonly = props.readonly, disabled = props.disabled, hideLabel = props.hideLabel, className = props.className, errorClassName = props.errorClassName, inputColor = props.inputColor, min = props.min, width = props.width, height = props.height, autoComplete = props.autoComplete, hideErrorMessage = props.hideErrorMessage, _whiteSpace = props.whiteSpace, whiteSpace = _whiteSpace === void 0 ? false : _whiteSpace, defaultValue = props.defaultValue;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)(), register = ref.register, errors = ref.formState.errors, control = ref.control;
    var pattern;
    switch(name){
        case "firstName":
        case "lastName":
        case "previousLandlordName":
            //*INFO: validate name, allow only letters, spaces, special characters like - ' and not allow icon
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .NAME_WITH_NUMBER_PATTERN */ .Jp,
                message: "Please enter a valid name"
            };
            break;
        case "email":
        case "previousLandlordEmail":
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .EMAIL_PATTERN */ .QI,
                message: "Please enter a valid email"
            };
            break;
        case "dateOfBirth":
            //*INFO: validate (MM/DD/YYYY), with a year between 1900 and 2099
            pattern = {
                value: /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/,
                message: "Please enter a valid date"
            };
            break;
        case "zipCode":
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .ZIP_CODE_PATTERN */ .fY,
                message: "Please enter a valid zip code"
            };
            break;
        case "vrTourUrl":
            pattern = {
                value: /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
                message: "Invalid URL"
            };
            break;
        case "monthlyIncome":
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .MONTHLY_INCOME_PATTERN */ .ZI,
                message: "Please enter a valid monthly income"
            };
            break;
        case "previousLandlordPhoneNumber":
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .RAW_PHONE_NUMBER_PATTERN */ .kc,
                message: "Please enter a valid phone number"
            };
            break;
        default:
            pattern = undefined;
    }
    var disabledProps = disabled ? {
        disabled: true,
        background: "gray.100",
        opacity: "0.7 !important",
        color: "gray.400",
        variant: "filled"
    } : {};
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .FormControl */ .NI, {
        isInvalid: !!lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errors, name, false),
        alignSelf: !label || hideLabel ? "flex-end" : undefined,
        className: className,
        width: width,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .Ug, {
                spacing: "14px",
                maxHeight: 6,
                marginBottom: label ? 2 : 0,
                position: "relative",
                children: [
                    label && !hideLabel && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .FormLabel */ .lX, {
                        whiteSpace: whiteSpace ? "nowrap" : "normal",
                        color: "gray.700",
                        lineHeight: 6,
                        marginBottom: 0,
                        marginInlineEnd: 0,
                        minWidth: "200px",
                        children: label
                    }),
                    helperText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Tooltip */ .u, {
                        label: helperText,
                        hasArrow: true,
                        placement: "right",
                        background: "gray.900",
                        color: "white",
                        fontSize: "sm",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                            textAlign: "center",
                            height: "20px",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(components_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                iconName: "information_line_blue.svg",
                                size: 20
                            })
                        })
                    })
                ]
            }),
            children ? children : type !== "number" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                height: height,
                type: type,
                autoComplete: autoComplete !== null && autoComplete !== void 0 ? autoComplete : name,
                placeholder: placeholder,
                isReadOnly: readonly,
                color: inputColor
            }, disabledProps, register(name, {
                required: isRequired ? "".concat(label !== null && label !== void 0 ? label : lodash_startCase__WEBPACK_IMPORTED_MODULE_1___default()(name), " is required") : false,
                pattern: pattern
            }))) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .Controller */ .Qr, {
                name: name,
                control: control,
                rules: {
                    required: true
                },
                render: function(param) {
                    var field = param.field;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberInput */ .Y2, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        defaultValue: defaultValue,
                        focusBorderColor: "teal.500"
                    }, field), {
                        min: min,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberInputField */ .zu, {}),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberInputStepper */ .Fi, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberIncrementStepper */ .WQ, {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .NumberDecrementStepper */ .Y_, {})
                                ]
                            })
                        ]
                    }));
                }
            }),
            !hideErrorMessage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .FormErrorMessage */ .J1, {
                className: errorClassName,
                children: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errors, "".concat(name, ".message"), "")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItem);


/***/ }),

/***/ 11665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);




var Icon = function(props) {
    var iconName = props.iconName, size = props.size, alt = props.alt, width = props.width, height = props.height, className = props.className, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave;
    var defaultSize = 32;
    var iconSize = size ? size : defaultSize;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: "/assets/icons/".concat(iconName),
        alt: alt,
        unoptimized: true,
        loading: "eager",
        width: width || iconSize,
        height: height || iconSize,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, "is-clickable", onClick)),
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 63516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ roommateDescriptionList; },
/* harmony export */   "UZ": function() { return /* binding */ TEST_PHONE_NUMBER; },
/* harmony export */   "i7": function() { return /* binding */ AMENITIES_ICON_MAP; },
/* harmony export */   "sO": function() { return /* binding */ defaultAmenities; },
/* harmony export */   "yH": function() { return /* binding */ MATTERPORT_DOMAIN; }
/* harmony export */ });
/* unused harmony export helperSMSLink */
var defaultAmenities = {
    title: "Additional Monthly amenities and Service Fee ($140/mo) includes:",
    utilityFee: "Flat rate utility fee",
    maintenance: "24/7 Emergency Maintenance",
    internet: "High-speed, unlimited WiFi",
    laundry: "In-house laundry",
    maidService: "Maid Service",
    smartTV: '50" Smart TV',
    lawnCare: "Lawn Care",
    events: "Exclusive Community and Events",
    homeRoomApp: "Custom-built HomeRoom App",
    creditScore: "Increase your credit score with each rent payment"
};
var helperSMSLink = "sms:+18162031186";
var roommateDescriptionList = [
    "Hi! We're looking for someone who enjoys a pleasant and laid back roomate dynamic. We're a group of people with different professions and hobbies, would love to find someone interesting to add to the mix!  A + if you like to go hiking or walks, enjoy sports or athletics or grab dinner.",
    "We\u2019re a mix of later-stage students and professionals. We were randomly paired together as roommates and it's worked out great. Looking maintain the chill and respectful dynamic we have established. Let's meet if that sounds like you!",
    "Eclectic group of nice, mature people here! We're all working professionals but as soon as we come home we like to chill, relax and chat about our days. Looking for someone who appreciates a moderately social but laid back vibe.",
    "We are a group of individuals in various age groups looking for someone who is clean, responsible, friendly and chill.\n  Looking forward to meeting you!",
    "We\u2019re a group of professionals and creative folks. Very chill, respectful and positive vibes. Cool with having friends over time to time. Prefer a clean person who helps out when needed."
];
var TEST_PHONE_NUMBER = "+15555555555";
var AMENITIES_ICON_MAP = {
    utilityFee: "fee.svg",
    maintenance: "maintenance.svg",
    internet: "wifi.svg",
    laundry: "washing_machine.svg",
    maidService: "clean.svg",
    smartTV: "TV.svg",
    lawnCare: "lawn.svg",
    events: "event.svg",
    homeRoomApp: "app.svg",
    creditScore: "payment.svg"
};
var MATTERPORT_DOMAIN = "matterport";


/***/ }),

/***/ 88501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cx": function() { return /* binding */ PHONE_NUMBER_PATTERN; },
/* harmony export */   "Ge": function() { return /* binding */ NAME_PATTERN; },
/* harmony export */   "H6": function() { return /* binding */ YEAR_PATTERN; },
/* harmony export */   "Jp": function() { return /* binding */ NAME_WITH_NUMBER_PATTERN; },
/* harmony export */   "QI": function() { return /* binding */ EMAIL_PATTERN; },
/* harmony export */   "Vo": function() { return /* binding */ DATE_OF_BIRTH_PATTERN; },
/* harmony export */   "ZI": function() { return /* binding */ MONTHLY_INCOME_PATTERN; },
/* harmony export */   "c8": function() { return /* binding */ MONTH_PATTERN; },
/* harmony export */   "fY": function() { return /* binding */ ZIP_CODE_PATTERN; },
/* harmony export */   "kc": function() { return /* binding */ RAW_PHONE_NUMBER_PATTERN; },
/* harmony export */   "mS": function() { return /* binding */ PASSWORD_PATTERN; },
/* harmony export */   "nB": function() { return /* binding */ RAW_US_PHONE_NUMBER_PATTERN; },
/* harmony export */   "rq": function() { return /* binding */ DAY_PATTERN; },
/* harmony export */   "v8": function() { return /* binding */ NUMBER_WITH_COMMA_PATTERN; },
/* harmony export */   "zC": function() { return /* binding */ NUMBER_PATTERN; }
/* harmony export */ });
var ZIP_CODE_PATTERN = /(^\d{4,5}$)|(^\d{5}-\d{4}$)/;
var PHONE_NUMBER_PATTERN = /^\(\d{3}\) \d{3}-\d{4}$/;
var RAW_PHONE_NUMBER_PATTERN = /^\+?1?\s*\(?-*\.*(\d{3})\)?\.*-*\s*(\d{3})\.*-*\s*(\d{4})$/;
var NAME_PATTERN = /^[a-zA-Z\u00C0-\u017F\s-']+$/;
var EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
var NUMBER_PATTERN = /^(\$)?(\d+)(\.\d+)?$/;
var NUMBER_WITH_COMMA_PATTERN = /\B(?=(\d{3})+(?!\d))/g;
var NAME_WITH_NUMBER_PATTERN = /^[a-zA-Z0-9\u00C0-\u017F\s-']+$/;
var RAW_US_PHONE_NUMBER_PATTERN = /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/;
//* INFO: validate password: upper and lower case letters, at least 8 characters and must contain digits
var PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
//* INFO: validate income: allow currency characters $ at the beginning of the string or not and allow decimal numbers with any digits after the decimal point
var MONTHLY_INCOME_PATTERN = /^(\$)?(\d+)(\.\d+)?$/;
//*INFO: validate day: between 1 and 31
var DAY_PATTERN = /^(0[1-9]|[12][0-9]|3[01])$/;
//*INFO: validate month: between 1 and 12
var MONTH_PATTERN = /^(0[1-9]|1[012])$/;
//*INFO: validate year: between 1900 and 2099
var YEAR_PATTERN = /^(19|20)\d\d$/;
//* INFO Check if dateOfBirth is valid
var DATE_OF_BIRTH_PATTERN = /^02[- /.]29[- /.]((19|20)([2468][048]|[13579][26]|0[48])|2000)|((0[469]|11)[- /.](0[1-9]|[12][0-9]|30)[- /.](19|20)[0-9]{2}|(0[13578]|1[02])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)[0-9]{2}|02[- /.](0[1-9]|1[0-9]|2[0-8])[- /.](19|20)[0-9]{2})$/;


/***/ }),

/***/ 9322:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var EFeatureFlags;
(function(EFeatureFlags) {
    EFeatureFlags["WEBSITE_LOGIN"] = "website-login";
    EFeatureFlags["WEBSITE_LISTING_PAGE_ENTIRE_HOUSE"] = "website-listing-page-entire-house";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_V2"] = "application-form-v2";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_OTP_VERIFY"] = "application-form-otp-verify";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_CRS_CHECK"] = "application-form-crs-check";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_SIGN_AGREEMENT"] = "application-form-sign-agreement";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_PAYMENT"] = "application-form-payment";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_ROOMMATE_SMS"] = "application-form-roommate-sms";
    EFeatureFlags["WEBSITE_APPLICATION_FORM_CHOOSE_UNIT_ON_SIDEBAR_47"] = "application-form-choose-unit-in-sidebar-47";
    EFeatureFlags["WEBSITE_PRICING_TABLE_WIFI"] = "website-pricing-table-wifi-50";
    EFeatureFlags["WEBSITE_CHATBOX"] = "website-chatbox-50";
    EFeatureFlags["OWNER_PORTAL_LOGIN"] = "owner-portal-login";
    EFeatureFlags["CMS"] = "cms";
    EFeatureFlags["OWNER_PORTAL"] = "owner-portal";
    EFeatureFlags["OWNER_PORTAL_FINANCIAL"] = "owner-portal-financial";
    EFeatureFlags["OWNER_PORTAL_LEASE"] = "owner-portal-lease";
    EFeatureFlags["OWNER_PORTAL_REPAIR"] = "owner-portal-repair";
    EFeatureFlags["CMS_PAYMENT_LIST"] = "cms-payment-list";
    EFeatureFlags["CMS_UNIT_MAIN_PHOTO"] = "cms-unit-main-photo";
    EFeatureFlags["PRICING_TABLE"] = "pricing-table";
})(EFeatureFlags || (EFeatureFlags = {}));
/* harmony default export */ __webpack_exports__["Z"] = (EFeatureFlags);


/***/ }),

/***/ 60431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OL": function() { return /* binding */ NavLink; },
/* harmony export */   "qd": function() { return /* binding */ EZIndexLayer; },
/* harmony export */   "yE": function() { return /* binding */ EBreakPoint; }
/* harmony export */ });
/* unused harmony export ThemeMode */
var ThemeMode;
(function(ThemeMode) {
    ThemeMode["LIGHT"] = "white";
    ThemeMode["DARK"] = "black";
})(ThemeMode || (ThemeMode = {}));
var NavLink;
(function(NavLink) {
    NavLink["LINK"] = "link";
    NavLink["BUTTON"] = "button";
    NavLink["DROPDOWN"] = "dropdown";
    NavLink["EMPTY_DROPDOWN"] = "empty-dropdown";
})(NavLink || (NavLink = {}));
var EZIndexLayer;
(function(EZIndexLayer) {
    EZIndexLayer[EZIndexLayer["BASE"] = 0] = "BASE";
    EZIndexLayer[EZIndexLayer["UPPER"] = 1] = "UPPER";
    EZIndexLayer[EZIndexLayer["INPUT_DROPDOWN"] = 1000] = "INPUT_DROPDOWN";
    EZIndexLayer[EZIndexLayer["OVER_INPUT_DROPDOWN"] = 1001] = "OVER_INPUT_DROPDOWN";
    EZIndexLayer[EZIndexLayer["CONTENT_VIEW"] = 1100] = "CONTENT_VIEW";
    EZIndexLayer[EZIndexLayer["WELCOME_BAR"] = 1150] = "WELCOME_BAR";
    EZIndexLayer[EZIndexLayer["FILTER_BAR"] = 1200] = "FILTER_BAR";
    EZIndexLayer[EZIndexLayer["NAV"] = 1300] = "NAV";
    EZIndexLayer[EZIndexLayer["OVER_CONTENT"] = 1150] = "OVER_CONTENT";
    EZIndexLayer[EZIndexLayer[// INFO: Follow z-index of chakra modal component
    // https://chakra-ui.com/docs/components/modal
    "MODAL"] = 1400] = "MODAL";
    EZIndexLayer[EZIndexLayer["OVERLAY"] = 1500] = "OVERLAY";
    EZIndexLayer[EZIndexLayer["TOAST"] = 9999] = "TOAST";
})(EZIndexLayer || (EZIndexLayer = {}));
var EBreakPoint;
(function(EBreakPoint) {
    EBreakPoint["BASE"] = "base";
    EBreakPoint["XS"] = "xs";
    EBreakPoint["SM"] = "sm";
    EBreakPoint["MD"] = "md";
    EBreakPoint["LG"] = "lg";
    EBreakPoint["XL"] = "xl";
})(EBreakPoint || (EBreakPoint = {}));


/***/ }),

/***/ 41894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var enums_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60431);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86229);



var getBreakPointValue = function(breakPoint) {
    switch(breakPoint){
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.XS */ .yE.XS:
            // INFO: using breakPoinTValue of sm because in this design we have min break point is sm
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.sm */ .g4.sm;
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.SM */ .yE.SM:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.sm */ .g4.sm;
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.MD */ .yE.MD:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.md */ .g4.md;
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.LG */ .yE.LG:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.lg */ .g4.lg;
        case enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EBreakPoint.XL */ .yE.XL:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.xl */ .g4.xl;
        default:
            return theme_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .breakPointValues.base */ .g4.base;
    }
};
var useBreakPoint = function(minBreakPoint, maxBreakPoint) {
    var minWidth = String(Number(getBreakPointValue(minBreakPoint).replace("px", "")) + 0.1) + "px";
    var settings = {
        minWidth: minWidth
    };
    if (maxBreakPoint) {
        settings.maxWidth = getBreakPointValue(maxBreakPoint);
    }
    var isMatched = (0,react_responsive__WEBPACK_IMPORTED_MODULE_2__.useMediaQuery)(settings);
    return isMatched;
};
/* harmony default export */ __webpack_exports__["Z"] = (useBreakPoint);


/***/ }),

/***/ 45949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFeatureFlagValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_unleash_flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68401);
/* harmony import */ var react_unleash_flags__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_unleash_flags__WEBPACK_IMPORTED_MODULE_1__);


function useFeatureFlagValue(name) {
    var singleEnvironment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), isEnabled = ref[0], setIsEnabled = ref[1];
    var flagsClient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(react_unleash_flags__WEBPACK_IMPORTED_MODULE_1__.FlagsContext);
    //* INFO: Flag name with environment
    var flagName = singleEnvironment ? name : "".concat("production", "-").concat(name);
    var flag = flagsClient ? flagsClient.getFlag(flagName) : undefined;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (flag) {
            //* INFO: Set flag value if fetched
            if (flag === null || flag === void 0 ? void 0 : flag.enabled) {
                setIsEnabled(true);
            } else {
                setIsEnabled(false);
            }
        }
    }, [
        flag
    ]);
    return {
        isEnabled: isEnabled,
        flagName: flagName
    };
};


/***/ }),

/***/ 19263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useStores; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var stores__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81436);


var storeContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(stores__WEBPACK_IMPORTED_MODULE_1__/* .rootStore */ .U);
var useStores = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(storeContext);
};


/***/ }),

/***/ 11922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ apply; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./enums/featureFlags/index.ts
var featureFlags = __webpack_require__(9322);
// EXTERNAL MODULE: ./hooks/useFeatureFlagValue.ts
var useFeatureFlagValue = __webpack_require__(45949);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(59876);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
// EXTERNAL MODULE: ./node_modules/chakra-ui-steps/dist/chakra-ui-steps.es.js
var chakra_ui_steps_es = __webpack_require__(47822);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./enums/common/index.ts
var common = __webpack_require__(71074);
// EXTERNAL MODULE: ./enums/theme/index.ts
var theme = __webpack_require__(60431);
// EXTERNAL MODULE: ./hooks/useBreakPoint.ts
var useBreakPoint = __webpack_require__(41894);
// EXTERNAL MODULE: ./hooks/useStores.ts
var useStores = __webpack_require__(19263);
// EXTERNAL MODULE: ./hooks/useUnsavedWarning.ts
var useUnsavedWarning = __webpack_require__(68834);
// EXTERNAL MODULE: ./node_modules/lodash/delay.js
var delay = __webpack_require__(98066);
var delay_default = /*#__PURE__*/__webpack_require__.n(delay);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/identity.js
var identity = __webpack_require__(6557);
var identity_default = /*#__PURE__*/__webpack_require__.n(identity);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__(35937);
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js
var mobxreact_esm = __webpack_require__(29323);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./API/error.ts
var API_error = __webpack_require__(76214);
// EXTERNAL MODULE: ./API/houseApplication/index.ts
var API_houseApplication = __webpack_require__(55262);
// EXTERNAL MODULE: ./routes/index.ts + 2 modules
var routes = __webpack_require__(1179);
// EXTERNAL MODULE: ./utils/common.ts
var utils_common = __webpack_require__(6628);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/applicationFormModalV2.styles.ts
var applicationFormModalV2_styles = __webpack_require__(82120);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/utils/index.ts + 12 modules
var utils = __webpack_require__(53722);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/constant.ts
var constant = __webpack_require__(29166);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/applicationForm.context.ts
var applicationForm_context = __webpack_require__(18265);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/components/FormSubmitted/index.tsx
var FormSubmitted = __webpack_require__(17040);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/components/StepsSideBar/index.tsx + 2 modules
var StepsSideBar = __webpack_require__(14190);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/utils/index.ts + 4 modules
var ApplicationFormModalV3_utils = __webpack_require__(70284);
;// CONCATENATED MODULE: ./components/pages/ApplyApplicationPage/index.tsx






/* eslint-disable max-lines */ 





























var isProduction = "production" === common/* EnvironmentEnum.PRODUCTION */.mf.PRODUCTION;
var NewApplicationForm = function() {
    var updateCompletedStepAndCompletedState = function updateCompletedStepAndCompletedState() {
        var ref;
        var lastCompletedStep = parseInt((ref = sessionStorage.getItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STEP */.G.APPLICATION_FORM_COMPLETED_STEP)) !== null && ref !== void 0 ? ref : "0");
        if (activeStep >= lastCompletedStep) {
            sessionStorage.setItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STEP */.G.APPLICATION_FORM_COMPLETED_STEP, "".concat(activeStep));
            var ref1;
            var lastCompletedState = (ref1 = sessionStorage.getItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STATE */.G.APPLICATION_FORM_COMPLETED_STATE)) !== null && ref1 !== void 0 ? ref1 : "";
            var newCompletedState = (0,ApplicationFormModalV3_utils/* getNewCompletedState */.lu)(activeStep, lastCompletedState);
            sessionStorage.setItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STATE */.G.APPLICATION_FORM_COMPLETED_STATE, newCompletedState);
        }
    };
    var handleCompleteScreeningStep = function handleCompleteScreeningStep() {
        if (activeStep === constant/* EApplicationStepBar.COMPLETE_SCREENING */.X0.COMPLETE_SCREENING) {
            //* INFO: if payment isn't expired, skip payment step
            if (completeScreeningStep === utils/* ECompleteScreeningSteps.PAYMENT_INFORMATION */.U1.PAYMENT_INFORMATION && !isPaymentExpired) {
                setCompleteScreeningStep(utils/* ECompleteScreeningSteps.DRIVER_LICENSE */.U1.DRIVER_LICENSE);
            }
        }
    };
    var validateDateOfBirth = function validateDateOfBirth() {
        var isShareYourDeetsStep = activeStep === constant/* EApplicationStepBar.SHARE_YOUR_DEETS */.X0.SHARE_YOUR_DEETS;
        var ref, ref1;
        //*INFO: default value in order to avoid Invalid Date return from new Date()
        var isValidDayOfMonth = (0,ApplicationFormModalV3_utils/* checkValidDayOfMonth */.hp)(Number((ref = formValue === null || formValue === void 0 ? void 0 : formValue.month) !== null && ref !== void 0 ? ref : dayjs_min_default()().month() + 1), Number(formValue === null || formValue === void 0 ? void 0 : formValue.day), Number((ref1 = formValue === null || formValue === void 0 ? void 0 : formValue.year) !== null && ref1 !== void 0 ? ref1 : dayjs_min_default()().year()));
        if (isShareYourDeetsStep && !isValidDayOfMonth) {
            var errorMessage = (formValue === null || formValue === void 0 ? void 0 : formValue.day) ? "Invalid day" : "Day is required";
            setError("day", {
                message: errorMessage
            });
        } else {
            clearErrors("day");
        }
    };
    var onClose = function onClose() {
        setIsLoading(true);
        router.push(routes/* default.home.value */.Z.home.value);
    };
    var ref, ref1;
    var method = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        defaultValues: {
            confirm: false,
            phoneNumber: "",
            moveInDate: new Date()
        }
    });
    var setDirty = (0,useUnsavedWarning/* default */.Z)().setDirty;
    var handleSubmit = method.handleSubmit, control = method.control, trigger = method.trigger, setError = method.setError, clearErrors = method.clearErrors, reset = method.reset, getValues = method.getValues, setValue = method.setValue;
    var ref2 = (0,react.useState)({}), previousFormValue = ref2[0], setPreviousFormValue = ref2[1];
    var formValue = (0,index_esm/* useWatch */.qo)({
        control: control
    });
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(false), isBackLoading = ref4[0], setIsBackLoading = ref4[1];
    var ref5 = (0,react.useState)(false), showApplicationForm = ref5[0], setShowApplicationForm = ref5[1];
    var ref6 = (0,chakra_ui_steps_es/* useSteps */.h4)({
        initialStep: 0
    }), nextStep = ref6.nextStep, activeStep = ref6.activeStep, setStep = ref6.setStep, previousStep = ref6.prevStep, resetStep = ref6.reset;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var ref7 = (0,react.useState)(false), isPaymentSuccessful = ref7[0], setIsPaymentSuccessful = ref7[1];
    var ref8 = (0,react.useState)(null), clientSecret = ref8[0], setClientSecret = ref8[1];
    var ref9 = (0,react.useState)(false), isDriverLicenseVerified = ref9[0], setIsDriverLicenseVerified = ref9[1];
    var ref10 = (0,react.useState)(false), isFetchContinueApplyingData = ref10[0], setIsFetchContinueApplyingData = ref10[1];
    var ref11 = (0,react.useState)(utils/* ECompleteScreeningSteps.PAYMENT_INFORMATION */.U1.PAYMENT_INFORMATION), completeScreeningStep = ref11[0], setCompleteScreeningStep = ref11[1];
    var ref12 = (0,react.useState)(undefined), clientInfo = ref12[0], setClientInfo = ref12[1];
    var ref13 = (0,react.useState)([]), checkedItems = ref13[0], setCheckedItems = ref13[1];
    var ref14 = (0,react.useState)(), currentHouseApplicationId = ref14[0], setCurrentHouseApplicationId = ref14[1];
    var ref15 = (0,useStores/* useStores */.m)(), houseApplicationStore = ref15.houseApplicationStore, cmsPolicyStore = ref15.cmsPolicyStore;
    var houseApplication = houseApplicationStore.houseApplication, isTestPhoneNumber = houseApplicationStore.isTestPhoneNumber, isPaymentExpired = houseApplicationStore.isPaymentExpired;
    var isUsingStepButton = [
        constant/* EApplicationStepBar.COMPLETE_SCREENING */.X0.COMPLETE_SCREENING,
        constant/* EApplicationStepBar.COMPLETED */.X0.COMPLETED
    ].includes(activeStep);
    var isMobileTablet = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.LG */.yE.LG);
    var steps = (0,react.useMemo)(function() {
        return (0,ApplicationFormModalV3_utils/* getApplicationSteps */.$n)();
    }, [
        handleNextStep,
        clientSecret,
        handlePreviousStep
    ]);
    var isDone = activeStep >= steps.length;
    var hasBackButton = activeStep > constant/* EApplicationStepBar.DO_YOU_QUALIFY */.X0.DO_YOU_QUALIFY;
    var ref16, ref17;
    var stepTitle = isDone ? "".concat(steps.length, ". ").concat((ref16 = (ref = steps[steps.length - 1]) === null || ref === void 0 ? void 0 : ref.label) !== null && ref16 !== void 0 ? ref16 : "") : "".concat(activeStep + 1, ". ").concat((ref17 = (ref1 = steps[activeStep]) === null || ref1 === void 0 ? void 0 : ref1.label) !== null && ref17 !== void 0 ? ref17 : "");
    var phoneNumber = (0,utils_common/* getRawUSPhoneNumber */.vM)((0,index_esm/* useWatch */.qo)({
        name: "phoneNumber",
        control: control,
        defaultValue: ""
    }));
    var isContinueApplying = query.isApplying, houseApplicationId = query.houseApplicationId, queryPhoneNumber = query.phoneNumber;
    function onSubmit() {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, referer, sourceUrl, currentUrl, lastName, firstName, ref1, lastCompletedState, ref2, ref3, dateOfBirth, monthlyIncome, previousMoveDate, ref4, previousMoveInDate, previousMoveOutDate, filteredFormValue, ref5, parseValues, ref6, updatedHouseApplication, ref7, updatedHouseApplication1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!((previousFormValue === null || previousFormValue === void 0 ? void 0 : previousFormValue.isDone) || !(0,utils_common/* hasChanges */.h9)(previousFormValue, formValue) || !phoneNumber)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        referer = localStorage.getItem(common/* LocalStorageKeyEnum.REFERRER */.eh.REFERRER) || get_default()(document, "referrer", "Not updated");
                        sourceUrl = referer || location.hostname || "Not updated";
                        currentUrl = get_default()(document, "URL", "") || get_default()(location, "href", "Not updated");
                        lastName = (formValue === null || formValue === void 0 ? void 0 : formValue.lastName) || ((ref = (0,utils_common/* extractFromFullName */.Y6)(formValue === null || formValue === void 0 ? void 0 : formValue.firstName)) === null || ref === void 0 ? void 0 : ref.lastName);
                        firstName = (formValue === null || formValue === void 0 ? void 0 : formValue.firstName) || "";
                        ;
                        lastCompletedState = (ref1 = sessionStorage.getItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STATE */.G.APPLICATION_FORM_COMPLETED_STATE)) !== null && ref1 !== void 0 ? ref1 : constant/* EApplicationCompletedStateV2.PHONE_NUMBER_SUBMITTED */.P5.PHONE_NUMBER_SUBMITTED;
                        _ctx.prev = 10;
                        ;
                        dateOfBirth = "".concat(formValue === null || formValue === void 0 ? void 0 : formValue.month, "/").concat(formValue === null || formValue === void 0 ? void 0 : formValue.day, "/").concat(formValue === null || formValue === void 0 ? void 0 : formValue.year);
                        if (dayjs_min_default()(dateOfBirth).isValid()) {
                            formValue.dateOfBirth = dateOfBirth;
                        }
                        !dayjs_min_default()(formValue === null || formValue === void 0 ? void 0 : formValue.dateOfBirth).isValid() && delete formValue.dateOfBirth;
                        (formValue === null || formValue === void 0 ? void 0 : (ref2 = formValue.ssn) === null || ref2 === void 0 ? void 0 : ref2.includes("X")) && delete formValue.ssn;
                        monthlyIncome = formValue === null || formValue === void 0 ? void 0 : (ref3 = formValue.monthlyIncome) === null || ref3 === void 0 ? void 0 : ref3.toString().replace("$", "");
                        previousMoveDate = get_default()(formValue, "previousMoveDate", []);
                        ref4 = (0,_sliced_to_array/* default */.Z)((0,ApplicationFormModalV3_utils/* validatePreviousMoveDate */.Eo)(previousMoveDate), 2), previousMoveInDate = ref4[0], previousMoveOutDate = ref4[1];
                        filteredFormValue = omit_default()(formValue, [
                            "id",
                            "month",
                            "day",
                            "year",
                            "otherReferrer",
                            "previousMoveDate"
                        ]);
                        ;
                        parseValues = pickBy_default()((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filteredFormValue), {
                            sourceUrl: sourceUrl,
                            currentUrl: currentUrl,
                            phoneNumber: phoneNumber,
                            firstName: firstName,
                            lastName: lastName,
                            isDone: activeStep >= steps.length - 1,
                            referrers: (0,ApplicationFormModalV3_utils/* getReferrers */.AF)(formValue, filteredFormValue),
                            monthlyIncome: Number(monthlyIncome),
                            previousLandlordPhoneNumber: (0,utils_common/* getRawUSPhoneNumber */.vM)((ref5 = filteredFormValue === null || filteredFormValue === void 0 ? void 0 : filteredFormValue.previousLandlordPhoneNumber) !== null && ref5 !== void 0 ? ref5 : ""),
                            previousMoveInDate: previousMoveInDate,
                            previousMoveOutDate: previousMoveOutDate,
                            lastCompletedState: lastCompletedState
                        }), (identity_default()));
                        setPreviousFormValue((0,_object_spread/* default */.Z)({}, filteredFormValue));
                        if (!(isContinueApplying && houseApplicationId)) {
                            _ctx.next = 29;
                            break;
                        }
                        ;
                        _ctx.next = 27;
                        return (0,API_houseApplication/* upsertHousesApplicationByApplicationId */.un)(omit_default()((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parseValues), {
                            creditScore: (ref6 = formValue === null || formValue === void 0 ? void 0 : formValue.creditScore) !== null && ref6 !== void 0 ? ref6 : 0
                        }), [
                            "confirm",
                            "defaultBuildiumUnitId"
                        ]), String(houseApplicationId));
                    case 27:
                        updatedHouseApplication = _ctx.sent;
                        setCurrentHouseApplicationId(updatedHouseApplication === null || updatedHouseApplication === void 0 ? void 0 : updatedHouseApplication.id);
                    case 29:
                        if (!((parseValues === null || parseValues === void 0 ? void 0 : parseValues.zipCode) && !currentHouseApplicationId)) {
                            _ctx.next = 31;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 31:
                        ;
                        _ctx.next = 34;
                        return (0,API_houseApplication/* upsertHousesApplicationByApplicationId */.un)(omit_default()((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parseValues), {
                            creditScore: (ref7 = formValue === null || formValue === void 0 ? void 0 : formValue.creditScore) !== null && ref7 !== void 0 ? ref7 : 0
                        }), [
                            "confirm",
                            "defaultBuildiumUnitId"
                        ]), currentHouseApplicationId);
                    case 34:
                        updatedHouseApplication1 = _ctx.sent;
                        setCurrentHouseApplicationId(updatedHouseApplication1 === null || updatedHouseApplication1 === void 0 ? void 0 : updatedHouseApplication1.id);
                        _ctx.next = 42;
                        break;
                    case 38:
                        _ctx.prev = 38;
                        _ctx.t0 = _ctx["catch"](10);
                        if (activeStep > constant/* EApplicationStepBar.COMPLETE_SCREENING */.X0.COMPLETE_SCREENING) {
                            react_toastify_esm/* toast.error */.Am.error("Please make sure you fulfill all fields before moving on");
                            resetStep();
                        }
                        (0,API_error/* handleError */.S)(_ctx.t0, "components/pages/ApplyApplicationPage/index.tsx", "onSubmit");
                    case 42:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    10,
                    38
                ]
            ]);
        }));
        return _onSubmit.apply(this, arguments);
    }
    function handleNextStep() {
        return _handleNextStep.apply(this, arguments);
    }
    function _handleNextStep() {
        _handleNextStep = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, isDoneCompleteScreening;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        isDoneCompleteScreening = (formValue === null || formValue === void 0 ? void 0 : formValue.driverLicenseFrontPhotoUrl) && (formValue === null || formValue === void 0 ? void 0 : formValue.driverLicenseBackPhotoUrl) ? isDriverLicenseVerified : !isDriverLicenseVerified && !isPaymentExpired;
                        if ((0,ApplicationFormModalV3_utils/* validateFormStep */.X7)(activeStep, formValue, isDoneCompleteScreening, isMobileTablet)) {
                            nextStep();
                            onSubmit();
                            activeStep === constant/* EApplicationStepBar.SHARE_YOUR_DEETS */.X0.SHARE_YOUR_DEETS && clearErrors("day");
                        } else {
                            trigger([
                                "confirm",
                                "firstName",
                                "lastName",
                                "email",
                                "dateOfBirth",
                                "ssn",
                                "month",
                                "year",
                                "zipCode",
                                "streetName",
                                "city",
                                "addressLine1",
                                "state",
                                "monthlyIncome",
                                "phoneNumber"
                            ]);
                            validateDateOfBirth();
                        }
                        (ref = document === null || document === void 0 ? void 0 : document.getElementById("confirm")) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handleNextStep.apply(this, arguments);
    }
    function fetchPolicy() {
        return _fetchPolicy.apply(this, arguments);
    }
    function _fetchPolicy() {
        _fetchPolicy = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return cmsPolicyStore.fetchCMSPolicyValue();
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,API_error/* handleError */.S)(_ctx.t0, "components/pages/ApplyApplicationPage/index.tsx", "fetchPolicy");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return _fetchPolicy.apply(this, arguments);
    }
    function handlePreviousStep() {
        return _handlePreviousStep.apply(this, arguments);
    }
    function _handlePreviousStep() {
        _handlePreviousStep = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsBackLoading(true);
                        try {
                            if (activeStep === constant/* EApplicationStepBar.COMPLETED */.X0.COMPLETED) {
                                setCompleteScreeningStep(utils/* ECompleteScreeningSteps.PAYSTUB_UPLOADER */.U1.PAYSTUB_UPLOADER);
                            }
                            previousStep();
                        } catch (error) {
                            (0,API_error/* handleError */.S)(error, "components/pages/ApplyApplicationPage/index.tsx", "handlePreviousStep");
                        } finally{
                            setIsLoading(false);
                            setIsBackLoading(false);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handlePreviousStep.apply(this, arguments);
    }
    function fetchClientInfo() {
        return _fetchClientInfo.apply(this, arguments);
    }
    function _fetchClientInfo() {
        _fetchClientInfo = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!(isContinueApplying && houseApplicationId)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return houseApplicationStore.fetchHouseApplicationById(String(houseApplicationId), String(queryPhoneNumber), 0);
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,API_error/* handleError */.S)(_ctx.t0, "components/pages/DetailPage/components/ApplicationFormModalV2", "prefillClientInfo");
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return _fetchClientInfo.apply(this, arguments);
    }
    function fetchContinueApplyingData(continueApplyingStep) {
        return _fetchContinueApplyingData.apply(this, arguments);
    }
    function _fetchContinueApplyingData() {
        _fetchContinueApplyingData = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(continueApplyingStep) {
            var completedStateListV2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        completedStateListV2 = Object.values(constant/* EApplicationCompletedStateV2 */.P5);
                        if (!(completedStateListV2[continueApplyingStep] === constant/* EApplicationCompletedStateV2.FULL_APPLICATION_COMPLETED */.P5.FULL_APPLICATION_COMPLETED)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setIsFetchContinueApplyingData(true);
                        setStep(continueApplyingStep);
                        if (continueApplyingStep > constant/* EApplicationStepBar.DO_YOU_QUALIFY */.X0.DO_YOU_QUALIFY) {
                            setValue("confirm", true);
                        }
                        setIsFetchContinueApplyingData(false);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _fetchContinueApplyingData.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        // *INFO: fetch init data
        fetchPolicy();
        sessionStorage.removeItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STEP */.G.APPLICATION_FORM_COMPLETED_STEP);
        sessionStorage.removeItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STATE */.G.APPLICATION_FORM_COMPLETED_STATE);
    }, []);
    (0,react.useEffect)(function() {
        if (isContinueApplying && houseApplicationId) {
            fetchClientInfo();
        }
    }, [
        houseApplicationId,
        isContinueApplying
    ]);
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            if (phoneNumber && !isDone && (formValue === null || formValue === void 0 ? void 0 : formValue.email)) {
                onSubmit();
            }
        }, 10000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        phoneNumber,
        formValue,
        currentHouseApplicationId
    ]);
    (0,react.useEffect)(function() {
        updateCompletedStepAndCompletedState();
        !isDone && setDirty(true) //* INFO: Enable unsaved changes warning
        ;
        if (phoneNumber && (formValue === null || formValue === void 0 ? void 0 : formValue.email)) {
            onSubmit();
        }
        if ((formValue === null || formValue === void 0 ? void 0 : formValue.email) && (formValue === null || formValue === void 0 ? void 0 : formValue.firstName) && (formValue === null || formValue === void 0 ? void 0 : formValue.lastName) && (isPaymentExpired || isTestPhoneNumber) && !isPaymentSuccessful) {
            (0,ApplicationFormModalV3_utils/* fetchClientSecret */.M6)(setClientSecret, setClientInfo, isProduction ? constant/* APPLICATION_FEE */.cX : constant/* APPLICATION_TEST_FEE */.Qw, formValue, clientInfo);
        }
        handleCompleteScreeningStep();
        setTimeout(function() {
            (0,ApplicationFormModalV3_utils/* logStepToAmplitude */.ed)(activeStep);
        }, 0);
    }, [
        activeStep,
        isDone,
        completeScreeningStep
    ]);
    (0,react.useEffect)(function() {
        if (isDriverLicenseVerified && activeStep !== constant/* EApplicationStepBar.DO_YOU_QUALIFY */.X0.DO_YOU_QUALIFY) {
            onSubmit();
        }
    }, [
        isDriverLicenseVerified
    ]);
    (0,react.useEffect)(function() {
        if (houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.id) {
            if (isContinueApplying && houseApplicationId && (houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.lastCompletedState)) {
                var continueApplyingStep = (0,ApplicationFormModalV3_utils/* getContinueApplyingStep */.mp)(houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.lastCompletedState);
                fetchContinueApplyingData(continueApplyingStep) //* Fetch all data before continue applying
                ;
            }
            (0,ApplicationFormModalV3_utils/* prefillClientInfo */.u5)(houseApplication, reset, getValues);
            if ((houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.driverLicenseFrontPhotoUrl) && (houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.driverLicenseBackPhotoUrl)) {
                setIsDriverLicenseVerified(true);
            }
        }
    }, [
        houseApplication
    ]);
    (0,react.useEffect)(function() {
        // *INFO: using delay time to wait for load steps theme
        delay_default()(function() {
            if (!showApplicationForm) {
                setShowApplicationForm(true);
            }
        }, 1000);
    }, []);
    (0,react.useEffect)(function() {
        if (isDriverLicenseVerified) {
            onSubmit();
        }
    }, [
        isDriverLicenseVerified
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationForm_context/* ApplicationContext.Provider */.Z.Provider, {
        value: {
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            isBackLoading: isBackLoading,
            setIsBackLoading: setIsBackLoading,
            nextStep: nextStep,
            setStep: setStep,
            handleNextStep: handleNextStep,
            handlePreviousStep: handlePreviousStep,
            paymentClientSecret: clientSecret,
            isPaymentSuccessful: isPaymentSuccessful,
            setIsPaymentSuccessful: setIsPaymentSuccessful,
            isDriverLicenseVerified: isDriverLicenseVerified,
            setIsDriverLicenseVerified: setIsDriverLicenseVerified,
            completeScreeningStep: completeScreeningStep,
            setCompleteScreeningStep: setCompleteScreeningStep,
            checkedItems: checkedItems,
            setCheckedItems: setCheckedItems
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
            position: "relative",
            height: {
                base: "full",
                lg: "auto"
            },
            minHeight: "100vh",
            flexDirection: {
                base: "column",
                lg: "row"
            },
            borderRadius: 0,
            opacity: showApplicationForm ? 1 : 0,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, method), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StepsSideBar/* default */.Z, {
                        steps: steps,
                        isShowOTPStep: false,
                        activeStep: activeStep,
                        setStep: setStep,
                        completeScreeningStep: completeScreeningStep
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        width: "full",
                        paddingY: 2,
                        marginTop: {
                            base: "96px !important",
                            lg: "8px !important"
                        },
                        height: 12,
                        paddingX: 4,
                        display: {
                            lg: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            fontWeight: 700,
                            lineHeight: 7,
                            fontSize: "lg",
                            color: "gray.700",
                            children: stepTitle
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_system_esm/* chakra.form */.m$.form, {
                        onSubmit: handleSubmit(onSubmit, onSubmit),
                        width: "full",
                        borderRadius: "0",
                        height: isDone ? "unset" : "full",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_steps_es/* Steps */.Rg, {
                                hidden: true,
                                activeStep: activeStep,
                                labelOrientation: "vertical",
                                responsive: false,
                                children: (0,utils_common/* getValidArray */._b)(steps).map(function(param) {
                                    var label = param.label, content = param.content;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_steps_es/* Step */.h8, {
                                        label: label,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                            spacing: 0,
                                            textAlign: "justify",
                                            background: "white",
                                            height: {
                                                base: "full",
                                                lg: "auto"
                                            },
                                            justifyContent: {
                                                base: "space-between",
                                                lg: "flex-start"
                                            },
                                            marginLeft: {
                                                base: 0,
                                                lg: 480
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                                    spacing: 0,
                                                    textAlign: "justify",
                                                    background: "white",
                                                    overflowY: {
                                                        base: "auto",
                                                        md: "hidden"
                                                    },
                                                    flexGrow: 0.9,
                                                    width: "full",
                                                    height: {
                                                        base: "full",
                                                        lg: "auto"
                                                    },
                                                    children: content
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                                    width: "full",
                                                    maxWidth: {
                                                        base: "full",
                                                        lg: constant/* DESKTOP_CONTAINER_WIDTH */.n2
                                                    },
                                                    alignItems: hasBackButton ? "space-between" : "center",
                                                    justifyContent: hasBackButton ? "space-between" : "center",
                                                    paddingBottom: {
                                                        base: 6,
                                                        md: 12,
                                                        lg: "auto"
                                                    },
                                                    spacing: 2,
                                                    paddingX: {
                                                        base: 4,
                                                        lg: activeStep === constant/* EApplicationStepBar.SHARE_YOUR_DEETS */.X0.SHARE_YOUR_DEETS ? 0 : 4
                                                    },
                                                    hidden: isDone || isUsingStepButton,
                                                    position: {
                                                        base: "fixed",
                                                        lg: "static"
                                                    },
                                                    bottom: 0,
                                                    zIndex: theme/* EZIndexLayer.MODAL */.qd.MODAL,
                                                    left: 0,
                                                    paddingTop: {
                                                        base: 4,
                                                        lg: "auto"
                                                    },
                                                    background: {
                                                        base: "white",
                                                        lg: "none"
                                                    },
                                                    children: [
                                                        hasBackButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomBackButton */.bQ, {
                                                            isLoading: isBackLoading,
                                                            onClick: handlePreviousStep,
                                                            variant: "solid",
                                                            children: constant/* EBottomButtonValue.BACK */.VF.BACK
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomButton */.x_, {
                                                            colorScheme: "teal",
                                                            variant: "solid",
                                                            iconSpacing: 2,
                                                            onClick: handleNextStep,
                                                            isLoading: isLoading,
                                                            rightIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ArrowForwardIcon */.mr, {}),
                                                            children: constant/* EBottomButtonValue.CONTINUE */.VF.CONTINUE
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, label);
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitted/* default */.Z, {
                                isDone: isDone,
                                onClose: onClose
                            })
                        ]
                    })
                ]
            }))
        })
    });
};
/* harmony default export */ var ApplyApplicationPage = ((0,mobxreact_esm/* observer */.Pi)(NewApplicationForm));

// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/applicationFormModalV3.styles.ts
var applicationFormModalV3_styles = __webpack_require__(42881);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/components/CompleteScreening/utils/index.ts + 2 modules
var CompleteScreening_utils = __webpack_require__(75433);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/constant.ts
var ApplicationFormModalV3_constant = __webpack_require__(21325);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/components/ApplicationInformation/index.tsx + 11 modules
var ApplicationInformation = __webpack_require__(88671);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/components/Payment/index.tsx
var Payment = __webpack_require__(78276);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/components/SelectSource/index.tsx
var SelectSource = __webpack_require__(94881);
;// CONCATENATED MODULE: ./components/pages/ApplyApplicationPage/utils/application-form-v3-handleSteps.tsx






function getNewApplicationSteps() {
    return [
        {
            label: ApplicationFormModalV3_utils/* EApplicationStepsLabel.APPLICATION_INFORMATION */.mi.APPLICATION_INFORMATION,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ApplicationInformation/* default */.Z, {
                hasPhoneNumberField: true
            })
        },
        {
            label: ApplicationFormModalV3_utils/* EApplicationStepsLabel.PAYMENT */.mi.PAYMENT,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Payment/* default */.Z, {})
        },
        {
            label: ApplicationFormModalV3_utils/* EApplicationStepsLabel.COMPLETE_SCREENING */.mi.COMPLETE_SCREENING,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectSource/* default */.Z, {})
        },
        {
            label: ApplicationFormModalV3_utils/* EApplicationStepsLabel.COMPLETED */.mi.COMPLETED
        }
    ];
}

;// CONCATENATED MODULE: ./components/pages/ApplyApplicationPage/application-form-v3.index.tsx






/* eslint-disable max-lines */ 






























var application_form_v3_index_isProduction = "production" === common/* EnvironmentEnum.PRODUCTION */.mf.PRODUCTION;
var NewApplicationFormV3 = function() {
    var updateCompletedStepAndCompletedState = function updateCompletedStepAndCompletedState() {
        var ref;
        var lastCompletedStep = parseInt((ref = sessionStorage.getItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STEP */.G.APPLICATION_FORM_COMPLETED_STEP)) !== null && ref !== void 0 ? ref : "0");
        if (activeStep >= lastCompletedStep) {
            sessionStorage.setItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STEP */.G.APPLICATION_FORM_COMPLETED_STEP, "".concat(activeStep));
            var ref1;
            var lastCompletedState = (ref1 = sessionStorage.getItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STATE */.G.APPLICATION_FORM_COMPLETED_STATE)) !== null && ref1 !== void 0 ? ref1 : "";
            var newCompletedState = (0,ApplicationFormModalV3_utils/* getNewCompletedState */.lu)(activeStep, lastCompletedState);
            sessionStorage.setItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STATE */.G.APPLICATION_FORM_COMPLETED_STATE, newCompletedState);
        }
    };
    var handleCompleteScreeningStep = function handleCompleteScreeningStep() {
        if (activeStep === ApplicationFormModalV3_constant/* EApplicationStepBar.COMPLETE_SCREENING */.X0.COMPLETE_SCREENING) {
            //* INFO: if payment isn't expired, skip payment step
            if (completeScreeningStep === CompleteScreening_utils/* ECompleteScreeningSteps.PAYMENT_INFORMATION */.U1.PAYMENT_INFORMATION && !isPaymentExpired) {
                setCompleteScreeningStep(CompleteScreening_utils/* ECompleteScreeningSteps.DRIVER_LICENSE */.U1.DRIVER_LICENSE);
            }
        }
    };
    var validateDateOfBirth = function validateDateOfBirth() {
        var isShareYourDeetsStep = activeStep === ApplicationFormModalV3_constant/* EApplicationStepBar.PAYMENT */.X0.PAYMENT;
        var ref, ref1;
        //*INFO: default value in order to avoid Invalid Date return from new Date()
        var isValidDayOfMonth = (0,ApplicationFormModalV3_utils/* checkValidDayOfMonth */.hp)(Number((ref = formValue === null || formValue === void 0 ? void 0 : formValue.month) !== null && ref !== void 0 ? ref : dayjs_min_default()().month() + 1), Number(formValue === null || formValue === void 0 ? void 0 : formValue.day), Number((ref1 = formValue === null || formValue === void 0 ? void 0 : formValue.year) !== null && ref1 !== void 0 ? ref1 : dayjs_min_default()().year()));
        if (isShareYourDeetsStep && !isValidDayOfMonth) {
            var errorMessage = (formValue === null || formValue === void 0 ? void 0 : formValue.day) ? "Invalid day" : "Day is required";
            setError("day", {
                message: errorMessage
            });
        } else {
            clearErrors("day");
        }
    };
    var onClose = function onClose() {
        setIsLoading(true);
        router.push(routes/* default.home.value */.Z.home.value);
    };
    var ref, ref1;
    var method = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        defaultValues: {
            confirm: false,
            phoneNumber: "",
            moveInDate: new Date()
        }
    });
    var setDirty = (0,useUnsavedWarning/* default */.Z)().setDirty;
    var handleSubmit = method.handleSubmit, control = method.control, trigger = method.trigger, setError = method.setError, clearErrors = method.clearErrors, reset = method.reset, getValues = method.getValues, setValue = method.setValue;
    var ref2 = (0,react.useState)({}), previousFormValue = ref2[0], setPreviousFormValue = ref2[1];
    var formValue = (0,index_esm/* useWatch */.qo)({
        control: control
    });
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(false), isBackLoading = ref4[0], setIsBackLoading = ref4[1];
    var ref5 = (0,react.useState)(false), showApplicationForm = ref5[0], setShowApplicationForm = ref5[1];
    var ref6 = (0,chakra_ui_steps_es/* useSteps */.h4)({
        initialStep: 0
    }), nextStep = ref6.nextStep, activeStep = ref6.activeStep, setStep = ref6.setStep, previousStep = ref6.prevStep, resetStep = ref6.reset;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var ref7 = (0,react.useState)(false), isPaymentSuccessful = ref7[0], setIsPaymentSuccessful = ref7[1];
    var ref8 = (0,react.useState)(null), clientSecret = ref8[0], setClientSecret = ref8[1];
    var ref9 = (0,react.useState)(false), isDriverLicenseVerified = ref9[0], setIsDriverLicenseVerified = ref9[1];
    var ref10 = (0,react.useState)(false), isFetchContinueApplyingData = ref10[0], setIsFetchContinueApplyingData = ref10[1];
    var ref11 = (0,react.useState)(CompleteScreening_utils/* ECompleteScreeningSteps.PAYMENT_INFORMATION */.U1.PAYMENT_INFORMATION), completeScreeningStep = ref11[0], setCompleteScreeningStep = ref11[1];
    var ref12 = (0,react.useState)(undefined), clientInfo = ref12[0], setClientInfo = ref12[1];
    var ref13 = (0,react.useState)([]), checkedItems = ref13[0], setCheckedItems = ref13[1];
    var ref14 = (0,react.useState)(), currentHouseApplicationId = ref14[0], setCurrentHouseApplicationId = ref14[1];
    var ref15 = (0,useStores/* useStores */.m)(), houseApplicationStore = ref15.houseApplicationStore, cmsPolicyStore = ref15.cmsPolicyStore;
    var houseApplication = houseApplicationStore.houseApplication, isTestPhoneNumber = houseApplicationStore.isTestPhoneNumber, isPaymentExpired = houseApplicationStore.isPaymentExpired;
    var isUsingStepButton = [
        ApplicationFormModalV3_constant/* EApplicationStepBar.PAYMENT */.X0.PAYMENT,
        ApplicationFormModalV3_constant/* EApplicationStepBar.COMPLETE_SCREENING */.X0.COMPLETE_SCREENING,
        ApplicationFormModalV3_constant/* EApplicationStepBar.COMPLETED */.X0.COMPLETED
    ].includes(activeStep);
    var isMobileTablet = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.LG */.yE.LG);
    var steps = (0,react.useMemo)(function() {
        return getNewApplicationSteps();
    }, [
        handleNextStep,
        clientSecret,
        handlePreviousStep
    ]);
    var isDone = activeStep >= steps.length - 1;
    var hasBackButton = activeStep > ApplicationFormModalV3_constant/* EApplicationStepBar.APPLICATION_INFORMATION */.X0.APPLICATION_INFORMATION;
    var ref16, ref17;
    var stepTitle = isDone ? "".concat(steps.length, ". ").concat((ref16 = (ref = steps[steps.length - 1]) === null || ref === void 0 ? void 0 : ref.label) !== null && ref16 !== void 0 ? ref16 : "") : "".concat(activeStep + 1, ". ").concat((ref17 = (ref1 = steps[activeStep]) === null || ref1 === void 0 ? void 0 : ref1.label) !== null && ref17 !== void 0 ? ref17 : "");
    var phoneNumber = (0,utils_common/* getRawUSPhoneNumber */.vM)((0,index_esm/* useWatch */.qo)({
        name: "phoneNumber",
        control: control,
        defaultValue: ""
    }));
    var isContinueApplying = query.isApplying, houseApplicationId = query.houseApplicationId, queryPhoneNumber = query.phoneNumber;
    function onSubmit() {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, referer, sourceUrl, currentUrl, lastName, firstName, ref1, lastCompletedState, ref2, ref3, dateOfBirth, monthlyIncome, previousMoveDate, ref4, previousMoveInDate, previousMoveOutDate, filteredFormValue, ref5, parseValues, ref6, updatedHouseApplication;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!((previousFormValue === null || previousFormValue === void 0 ? void 0 : previousFormValue.isDone) || !(0,utils_common/* hasChanges */.h9)(previousFormValue, formValue) || !phoneNumber)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        referer = localStorage.getItem(common/* LocalStorageKeyEnum.REFERRER */.eh.REFERRER) || get_default()(document, "referrer", "Not updated");
                        sourceUrl = referer || location.hostname || "Not updated";
                        currentUrl = get_default()(document, "URL", "") || get_default()(location, "href", "Not updated");
                        lastName = (formValue === null || formValue === void 0 ? void 0 : formValue.lastName) || ((ref = (0,utils_common/* extractFromFullName */.Y6)(formValue === null || formValue === void 0 ? void 0 : formValue.firstName)) === null || ref === void 0 ? void 0 : ref.lastName);
                        firstName = (formValue === null || formValue === void 0 ? void 0 : formValue.firstName) || "";
                        ;
                        lastCompletedState = (ref1 = sessionStorage.getItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STATE */.G.APPLICATION_FORM_COMPLETED_STATE)) !== null && ref1 !== void 0 ? ref1 : ApplicationFormModalV3_constant/* EApplicationCompletedStateV3.PHONE_NUMBER_SUBMITTED */.xK.PHONE_NUMBER_SUBMITTED;
                        _ctx.prev = 10;
                        ;
                        dateOfBirth = "".concat(formValue === null || formValue === void 0 ? void 0 : formValue.month, "/").concat(formValue === null || formValue === void 0 ? void 0 : formValue.day, "/").concat(formValue === null || formValue === void 0 ? void 0 : formValue.year);
                        if (dayjs_min_default()(dateOfBirth).isValid()) {
                            formValue.dateOfBirth = dateOfBirth;
                        }
                        !dayjs_min_default()(formValue === null || formValue === void 0 ? void 0 : formValue.dateOfBirth).isValid() && delete formValue.dateOfBirth;
                        (formValue === null || formValue === void 0 ? void 0 : (ref2 = formValue.ssn) === null || ref2 === void 0 ? void 0 : ref2.includes("X")) && delete formValue.ssn;
                        monthlyIncome = formValue === null || formValue === void 0 ? void 0 : (ref3 = formValue.monthlyIncome) === null || ref3 === void 0 ? void 0 : ref3.toString().replace("$", "");
                        previousMoveDate = get_default()(formValue, "previousMoveDate", []);
                        ref4 = (0,_sliced_to_array/* default */.Z)((0,ApplicationFormModalV3_utils/* validatePreviousMoveDate */.Eo)(previousMoveDate), 2), previousMoveInDate = ref4[0], previousMoveOutDate = ref4[1];
                        filteredFormValue = omit_default()(formValue, [
                            "id",
                            "month",
                            "day",
                            "year",
                            "otherReferrer",
                            "previousMoveDate",
                            "paymentConfirm",
                            "promotionCode"
                        ]);
                        ;
                        parseValues = pickBy_default()((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filteredFormValue), {
                            sourceUrl: sourceUrl,
                            currentUrl: currentUrl,
                            phoneNumber: phoneNumber,
                            firstName: firstName,
                            lastName: lastName,
                            isDone: activeStep >= steps.length - 1,
                            referrers: (0,ApplicationFormModalV3_utils/* getReferrers */.AF)(formValue, filteredFormValue),
                            monthlyIncome: Number(monthlyIncome),
                            previousLandlordPhoneNumber: (0,utils_common/* getRawUSPhoneNumber */.vM)((ref5 = filteredFormValue === null || filteredFormValue === void 0 ? void 0 : filteredFormValue.previousLandlordPhoneNumber) !== null && ref5 !== void 0 ? ref5 : ""),
                            previousMoveInDate: previousMoveInDate,
                            previousMoveOutDate: previousMoveOutDate,
                            lastCompletedState: lastCompletedState,
                            lengthOfStay: Number(formValue === null || formValue === void 0 ? void 0 : formValue.lengthOfStay)
                        }), (identity_default()));
                        setPreviousFormValue((0,_object_spread/* default */.Z)({}, filteredFormValue));
                        ;
                        _ctx.next = 26;
                        return (0,API_houseApplication/* upsertHousesApplicationByApplicationId */.un)(omit_default()((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parseValues), {
                            creditScore: (ref6 = formValue === null || formValue === void 0 ? void 0 : formValue.creditScore) !== null && ref6 !== void 0 ? ref6 : 0
                        }), [
                            "confirm",
                            "defaultBuildiumUnitId"
                        ]), currentHouseApplicationId);
                    case 26:
                        updatedHouseApplication = _ctx.sent;
                        setCurrentHouseApplicationId(updatedHouseApplication === null || updatedHouseApplication === void 0 ? void 0 : updatedHouseApplication.id);
                        _ctx.next = 34;
                        break;
                    case 30:
                        _ctx.prev = 30;
                        _ctx.t0 = _ctx["catch"](10);
                        if (activeStep > ApplicationFormModalV3_constant/* EApplicationStepBar.COMPLETE_SCREENING */.X0.COMPLETE_SCREENING) {
                            react_toastify_esm/* toast.error */.Am.error("Please make sure you fulfill all fields before moving on");
                            resetStep();
                        }
                        (0,API_error/* handleError */.S)(_ctx.t0, "components/pages/ApplyApplicationPage/index.tsx", "onSubmit");
                    case 34:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    10,
                    30
                ]
            ]);
        }));
        return _onSubmit.apply(this, arguments);
    }
    function handleNextStep() {
        return _handleNextStep.apply(this, arguments);
    }
    function _handleNextStep() {
        _handleNextStep = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if ((0,ApplicationFormModalV3_utils/* validateFormStep */.X7)(activeStep, formValue, isMobileTablet)) {
                            nextStep();
                            activeStep === ApplicationFormModalV3_constant/* EApplicationStepBar.PAYMENT */.X0.PAYMENT && clearErrors("day");
                        } else {
                            trigger([
                                "confirm",
                                "firstName",
                                "lastName",
                                "email",
                                "dateOfBirth",
                                "ssn",
                                "month",
                                "year",
                                "zipCode",
                                "streetName",
                                "city",
                                "addressLine1",
                                "state",
                                "monthlyIncome",
                                "phoneNumber"
                            ]);
                            validateDateOfBirth();
                        }
                        (ref = document === null || document === void 0 ? void 0 : document.getElementById("confirm")) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handleNextStep.apply(this, arguments);
    }
    function fetchPolicy() {
        return _fetchPolicy.apply(this, arguments);
    }
    function _fetchPolicy() {
        _fetchPolicy = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return cmsPolicyStore.fetchCMSPolicyValue();
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,API_error/* handleError */.S)(_ctx.t0, "components/pages/ApplyApplicationPage/index.tsx", "fetchPolicy");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return _fetchPolicy.apply(this, arguments);
    }
    function handlePreviousStep() {
        return _handlePreviousStep.apply(this, arguments);
    }
    function _handlePreviousStep() {
        _handlePreviousStep = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsBackLoading(true);
                        try {
                            if (activeStep === ApplicationFormModalV3_constant/* EApplicationStepBar.COMPLETED */.X0.COMPLETED) {
                                setCompleteScreeningStep(CompleteScreening_utils/* ECompleteScreeningSteps.PAYSTUB_UPLOADER */.U1.PAYSTUB_UPLOADER);
                            }
                            previousStep();
                        } catch (error) {
                            (0,API_error/* handleError */.S)(error, "components/pages/ApplyApplicationPage/index.tsx", "handlePreviousStep");
                        } finally{
                            setIsLoading(false);
                            setIsBackLoading(false);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handlePreviousStep.apply(this, arguments);
    }
    function fetchClientInfo() {
        return _fetchClientInfo.apply(this, arguments);
    }
    function _fetchClientInfo() {
        _fetchClientInfo = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!(isContinueApplying && houseApplicationId)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return houseApplicationStore.fetchHouseApplicationById(String(houseApplicationId), String(queryPhoneNumber), 0);
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,API_error/* handleError */.S)(_ctx.t0, "components/pages/DetailPage/components/ApplicationFormModalV3", "prefillClientInfo");
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return _fetchClientInfo.apply(this, arguments);
    }
    function fetchContinueApplyingData(continueApplyingStep) {
        return _fetchContinueApplyingData.apply(this, arguments);
    }
    function _fetchContinueApplyingData() {
        _fetchContinueApplyingData = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(continueApplyingStep) {
            var completedStateListV2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        completedStateListV2 = Object.values(ApplicationFormModalV3_constant/* EApplicationCompletedStateV3 */.xK);
                        if (!(completedStateListV2[continueApplyingStep] === ApplicationFormModalV3_constant/* EApplicationCompletedStateV3.FULL_APPLICATION_COMPLETED */.xK.FULL_APPLICATION_COMPLETED)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setIsFetchContinueApplyingData(true);
                        setStep(continueApplyingStep);
                        if (continueApplyingStep > ApplicationFormModalV3_constant/* EApplicationStepBar.APPLICATION_INFORMATION */.X0.APPLICATION_INFORMATION) {
                            setValue("confirm", true);
                        }
                        setIsFetchContinueApplyingData(false);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _fetchContinueApplyingData.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        // *INFO: fetch init data
        fetchPolicy();
        var ref;
        sessionStorage.setItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STATE */.G.APPLICATION_FORM_COMPLETED_STATE, (ref = houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.lastCompletedState) !== null && ref !== void 0 ? ref : "");
        var ref1;
        sessionStorage.setItem(common/* ESessionStorageKey.APPLICATION_FORM_COMPLETED_STEP */.G.APPLICATION_FORM_COMPLETED_STEP, (ref1 = houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.lastCompletedState) !== null && ref1 !== void 0 ? ref1 : "0");
    }, []);
    (0,react.useEffect)(function() {
        if (isContinueApplying && houseApplicationId) {
            fetchClientInfo();
        }
    }, [
        houseApplicationId,
        isContinueApplying
    ]);
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            if (phoneNumber && !isDone && (formValue === null || formValue === void 0 ? void 0 : formValue.email)) {
                onSubmit();
            }
        }, 10000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        phoneNumber,
        formValue,
        currentHouseApplicationId
    ]);
    (0,react.useEffect)(function() {
        updateCompletedStepAndCompletedState();
        !isDone && setDirty(true) //* INFO: Enable unsaved changes warning
        ;
        if (phoneNumber && (formValue === null || formValue === void 0 ? void 0 : formValue.email)) {
            onSubmit();
        }
        if ((formValue === null || formValue === void 0 ? void 0 : formValue.email) && (formValue === null || formValue === void 0 ? void 0 : formValue.firstName) && (formValue === null || formValue === void 0 ? void 0 : formValue.lastName) && (isPaymentExpired || isTestPhoneNumber) && !isPaymentSuccessful) {
            (0,ApplicationFormModalV3_utils/* fetchClientSecret */.M6)(setClientSecret, setClientInfo, application_form_v3_index_isProduction ? ApplicationFormModalV3_constant/* APPLICATION_FEE */.cX : ApplicationFormModalV3_constant/* APPLICATION_TEST_FEE */.Qw, formValue, clientInfo);
        }
        handleCompleteScreeningStep();
        setTimeout(function() {
            (0,ApplicationFormModalV3_utils/* logStepToAmplitude */.ed)(activeStep);
        }, 0);
    }, [
        activeStep,
        isDone,
        completeScreeningStep
    ]);
    (0,react.useEffect)(function() {
        if (isDriverLicenseVerified && activeStep !== ApplicationFormModalV3_constant/* EApplicationStepBar.APPLICATION_INFORMATION */.X0.APPLICATION_INFORMATION) {
            onSubmit();
        }
    }, [
        isDriverLicenseVerified
    ]);
    (0,react.useEffect)(function() {
        if (houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.id) {
            (0,ApplicationFormModalV3_utils/* prefillClientInfo */.u5)(houseApplication, reset, getValues);
            if ((houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.driverLicenseFrontPhotoUrl) && (houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.driverLicenseBackPhotoUrl)) {
                setIsDriverLicenseVerified(true);
            }
        }
    }, [
        houseApplication
    ]);
    (0,react.useEffect)(function() {
        // *INFO: using delay time to wait for load steps theme
        delay_default()(function() {
            if (!showApplicationForm) {
                setShowApplicationForm(true);
            }
        }, 1000);
    }, []);
    (0,react.useEffect)(function() {
        if (isDriverLicenseVerified) {
            onSubmit();
        }
    }, [
        isDriverLicenseVerified
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationForm_context/* ApplicationContext.Provider */.Z.Provider, {
        value: {
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            isBackLoading: isBackLoading,
            setIsBackLoading: setIsBackLoading,
            nextStep: nextStep,
            setStep: setStep,
            handleNextStep: handleNextStep,
            handlePreviousStep: handlePreviousStep,
            paymentClientSecret: clientSecret,
            isPaymentSuccessful: isPaymentSuccessful,
            setIsPaymentSuccessful: setIsPaymentSuccessful,
            isDriverLicenseVerified: isDriverLicenseVerified,
            setIsDriverLicenseVerified: setIsDriverLicenseVerified,
            completeScreeningStep: completeScreeningStep,
            setCompleteScreeningStep: setCompleteScreeningStep,
            checkedItems: checkedItems,
            setCheckedItems: setCheckedItems
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
            position: "relative",
            height: {
                base: "full",
                lg: "auto"
            },
            minHeight: "100vh",
            flexDirection: {
                base: "column",
                lg: "row"
            },
            borderRadius: 0,
            opacity: showApplicationForm ? 1 : 0,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, method), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StepsSideBar/* default */.Z, {
                        steps: steps,
                        isShowOTPStep: false,
                        activeStep: activeStep,
                        setStep: setStep,
                        completeScreeningStep: completeScreeningStep
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        width: "full",
                        paddingY: 2,
                        marginTop: {
                            base: "96px !important",
                            lg: "8px !important"
                        },
                        height: 12,
                        paddingX: 4,
                        display: {
                            lg: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            fontWeight: 700,
                            lineHeight: 7,
                            fontSize: "lg",
                            color: "gray.700",
                            children: stepTitle
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_system_esm/* chakra.form */.m$.form, {
                        onSubmit: handleSubmit(onSubmit, onSubmit),
                        width: "full",
                        borderRadius: "0",
                        height: isDone ? "unset" : "full",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_steps_es/* Steps */.Rg, {
                                hidden: true,
                                activeStep: activeStep,
                                labelOrientation: "vertical",
                                responsive: false,
                                children: (0,utils_common/* getValidArray */._b)(steps).map(function(param) {
                                    var label = param.label, content = param.content;
                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_steps_es/* Step */.h8, {
                                        label: label,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                            spacing: 0,
                                            textAlign: "justify",
                                            background: "white",
                                            height: {
                                                base: "full",
                                                lg: "auto"
                                            },
                                            justifyContent: {
                                                base: "space-between",
                                                lg: "flex-start"
                                            },
                                            marginLeft: {
                                                base: 0,
                                                lg: 480
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                                    spacing: 0,
                                                    textAlign: "justify",
                                                    background: "white",
                                                    overflowY: "auto",
                                                    flexGrow: 0.9,
                                                    width: "full",
                                                    height: {
                                                        base: "full",
                                                        lg: "auto"
                                                    },
                                                    children: content
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                                    width: "full",
                                                    maxWidth: {
                                                        base: "full",
                                                        lg: ApplicationFormModalV3_constant/* DESKTOP_CONTAINER_WIDTH */.n2
                                                    },
                                                    alignItems: hasBackButton ? "space-between" : "center",
                                                    justifyContent: hasBackButton ? "space-between" : "center",
                                                    paddingBottom: {
                                                        base: 6,
                                                        md: 12,
                                                        lg: "auto"
                                                    },
                                                    spacing: 2,
                                                    paddingX: {
                                                        base: 4,
                                                        lg: activeStep === ApplicationFormModalV3_constant/* EApplicationStepBar.PAYMENT */.X0.PAYMENT ? 0 : 4
                                                    },
                                                    hidden: isDone || isUsingStepButton,
                                                    position: {
                                                        base: "fixed",
                                                        lg: "static"
                                                    },
                                                    bottom: 0,
                                                    zIndex: theme/* EZIndexLayer.MODAL */.qd.MODAL,
                                                    left: 0,
                                                    paddingTop: {
                                                        base: 4,
                                                        lg: "auto"
                                                    },
                                                    background: {
                                                        base: "white",
                                                        lg: "none"
                                                    },
                                                    children: [
                                                        hasBackButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV3_styles/* BottomBackButton */.bQ, {
                                                            isLoading: isBackLoading,
                                                            onClick: handlePreviousStep,
                                                            variant: "solid",
                                                            children: ApplicationFormModalV3_constant/* EBottomButtonValue.BACK */.VF.BACK
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV3_styles/* BottomButton */.x_, {
                                                            colorScheme: "teal",
                                                            variant: "solid",
                                                            iconSpacing: 2,
                                                            onClick: handleNextStep,
                                                            isLoading: isLoading,
                                                            rightIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ArrowForwardIcon */.mr, {}),
                                                            isDisabled: (formValue === null || formValue === void 0 ? void 0 : formValue.confirm) === false,
                                                            children: ApplicationFormModalV3_constant/* EBottomButtonValue.CONTINUE */.VF.CONTINUE
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, label);
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitted/* default */.Z, {
                                isDone: isDone,
                                onClose: onClose
                            })
                        ]
                    })
                ]
            }))
        })
    });
};
/* harmony default export */ var application_form_v3_index = ((0,mobxreact_esm/* observer */.Pi)(NewApplicationFormV3));

;// CONCATENATED MODULE: ./pages/apply/index.tsx






var apply_ApplyApplicationPage = function() {
    var ref = (0,useFeatureFlagValue/* default */.Z)(featureFlags/* default.WEBSITE_APPLICATION_FORM_V2 */.Z.WEBSITE_APPLICATION_FORM_V2), isEnableApplicationFormV2 = ref.isEnabled;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                        children: "HomeRoom Apply"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "icon",
                        href: "/favicon_black.png"
                    })
                ]
            }),
            isEnableApplicationFormV2 === false && isEnableApplicationFormV2 !== undefined && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(application_form_v3_index, {}),
            isEnableApplicationFormV2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ApplyApplicationPage, {})
        ]
    });
};
/* harmony default export */ var apply = (apply_ApplyApplicationPage);


/***/ }),

/***/ 8650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46052);
/* harmony import */ var _emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79313);


function chakraShouldForwardProp(CkComponent, baseStyle) {
    return (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)(CkComponent, {
        shouldForwardProp: function(prop) {
            // *INFO:  don't forward Chakra's props
            var isChakraProp = !(0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .shouldForwardProp */ .x9)(prop);
            if (isChakraProp) return false;
            // *INFO: forward valid HTML props
            var isValidProp = (0,_emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(prop);
            if (isValidProp) return true;
            // *INFO: else, only forward `sample` prop
            return [
                "sample"
            ].includes(prop);
        },
        baseStyle: baseStyle
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (chakraShouldForwardProp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2453,4838,7662,8499,5106,2088,3789,7536,2547,8018,4530,352,6896,7333,2069,4386,1268,9574,1175,3152,5069,6960,9774,2888,179], function() { return __webpack_exec__(97174); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);